// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.label-head {
   color: #777;
   display: block;
   font-size: 14px;
   font-weight: 400;
   margin: 15px 0 0;
   padding-bottom: 3px;
}

.div-company {
   padding: 10px 20px;
   margin-top: 60px;
   margin-left: 30px;
}

input, textarea, select {
   background: transparent;
   border: 1px solid #e5e5e5;
   border-radius: 2px;
   display: block;
   font-size: 13px;
   outline: none;
   padding: 5px;
   resize: none;
   width: 80%;
}

.save-metadata {
   margin-top: 170px;
   text-align: right;
}

.upload-metadata {
   margin-top: 200px;
   text-align: right;
}

.tool-icon {
   margin-right: 25px;
   text-align: right;
}

.mat-raised-button {
   line-height: 30px;
}

#btn_edit {
   display: inline-block;
}

#btn_cancel {
   display: none;
}

#btn_saveType {
   display: inline-block;
}

::ng-deep .mat-button:hover .mat-button-focus-overlay {
   opacity: 0.04 !important;
}

.mat-icon-button {
   padding: 0;
   min-width: 0;
   width: 40px;
   height: 50px;
   flex-shrink: 0;
   line-height: 40px;
   border-radius: 50%;
}

:host::ng-deep .mat-expansion-panel {
   box-sizing: content-box;
   display: block;
   margin: 0;
   border-radius: 4px;
   transition: margin 225ms cubic-bezier(0.4, 0, 0.2, 1),box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
   height: 100%;
   width: 100%;
}

.mat-expansion-panel-header.mat-expanded {
   height: 64px;
}

.box-space{
   width: 100%;
   margin-right: 4px;
}

mat-accordion {
   width: 100%;
}

.column {
   width: 33.33%;
   float: left;
   padding: 10px;
   box-sizing: border-box;
}

.column-full {
   width: 100%;
   float: none;
}

.container {
   width: 100%;
   overflow: hidden;
}

mat-expansion-panel-header {
   padding-left: 57px;
}

.panel-body {
   touch-action: none;
   padding: 0 24px 5px;
}

.profile-accordion {
   display:inline-block;
   padding: 15px 15px 0px 15px;
}

.profile-accordion-collapse {
   display:inline-block;
   padding: 0px 15px 0px 15px;
}

.profile-scroll {
   height: 100%;
   overflow-y: auto;
}

.logo {
   padding: 10px;
   text-align: center;
}

.logo img {
   background-color: #fff;
}

.container-logo {
   position: relative;
   cursor: pointer;
   min-height: 18px;
   width: 60px;
}

.container-logo .change {
   background: rgba(0, 0, 0, .54);
   color: white;
   font-size: 12px;
   position: absolute;
   bottom: 0;
   left: 0;
   right: 0;
   padding: 3px;
   opacity: 0;
   text-align: center;
   transition: opacity .2s;
}

.container-logo:hover .change {
   opacity: 1;
}

.inline {
   margin:10px;
   float:left;/*Add float left*/
}

.align-info {
   line-height: 1.6;
   margin-top: 10px;
   margin-bottom: 8px;
   padding: 5px 16px 12px 5px;
}

.align-logo-vertical {
   line-height: 1.6;
   margin-top: 10px;
   padding: 5px 16px 12px 5px;
}

.align-logo-horizontal {
   line-height: 1.6;
   padding: 5px 16px 12px 5px;
}

.cert-card {
   padding-left: 16px;
}

.cert-row {
   display: flex;
   align-items: baseline;
   padding: 4px 0;
}

.cert-label {
   width: 120px;
   flex-shrink: 0;
   white-space: nowrap;
   color: #777;
   font-size: 14px;
   font-weight: 400;
}

.cert-value {
   white-space: nowrap;
   color: #333;
}

.expire-badge {
   display: inline-block;
   padding: 3px 12px;
   border-radius: 6px;
   font-size: 13px;
   font-weight: 600;
   line-height: 1.6;
}

.expire-green {
   padding: 0;
   background-color: transparent;
   color: #333;
}

.expire-yellow {
   background-color: #facc15;
   color: #1a1a1a;
   animation: blink-yellow 1s infinite;
}

.expire-red {
   background-color: #ef4444;
   color: #fff;
   animation: blink-red 0.8s infinite;
}

.expire-expired {
   background-color: #ef4444;
   color: #fff;
}

@keyframes blink-yellow {
   0%, 100% {
      opacity: 1;
   }
   50% {
      opacity: 0.25;
   }
}

@keyframes blink-red {
   0%, 100% {
      opacity: 1;
   }
   50% {
      opacity: 0.2;
   }
}
`, "",{"version":3,"sources":["webpack://./src/app/admin/company-profile/company-profile.component.css"],"names":[],"mappings":"AAAA;GACG,WAAW;GACX,cAAc;GACd,eAAe;GACf,gBAAgB;GAChB,gBAAgB;GAChB,mBAAmB;AACtB;;AAEA;GACG,kBAAkB;GAClB,gBAAgB;GAChB,iBAAiB;AACpB;;AAEA;GACG,uBAAuB;GACvB,yBAAyB;GACzB,kBAAkB;GAClB,cAAc;GACd,eAAe;GACf,aAAa;GACb,YAAY;GACZ,YAAY;GACZ,UAAU;AACb;;AAEA;GACG,iBAAiB;GACjB,iBAAiB;AACpB;;AAEA;GACG,iBAAiB;GACjB,iBAAiB;AACpB;;AAEA;GACG,kBAAkB;GAClB,iBAAiB;AACpB;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,qBAAqB;AACxB;;AAEA;GACG,aAAa;AAChB;;AAEA;GACG,qBAAqB;AACxB;;AAEA;GACG,wBAAwB;AAC3B;;AAEA;GACG,UAAU;GACV,YAAY;GACZ,WAAW;GACX,YAAY;GACZ,cAAc;GACd,iBAAiB;GACjB,kBAAkB;AACrB;;AAEA;GACG,uBAAuB;GACvB,cAAc;GACd,SAAS;GACT,kBAAkB;GAClB,mGAAmG;GACnG,YAAY;GACZ,WAAW;AACd;;AAEA;GACG,YAAY;AACf;;AAEA;GACG,WAAW;GACX,iBAAiB;AACpB;;AAEA;GACG,WAAW;AACd;;AAEA;GACG,aAAa;GACb,WAAW;GACX,aAAa;GACb,sBAAsB;AACzB;;AAEA;GACG,WAAW;GACX,WAAW;AACd;;AAEA;GACG,WAAW;GACX,gBAAgB;AACnB;;AAEA;GACG,kBAAkB;AACrB;;AAEA;GACG,kBAAkB;GAClB,mBAAmB;AACtB;;AAEA;GACG,oBAAoB;GACpB,2BAA2B;AAC9B;;AAEA;GACG,oBAAoB;GACpB,0BAA0B;AAC7B;;AAEA;GACG,YAAY;GACZ,gBAAgB;AACnB;;AAEA;GACG,aAAa;GACb,kBAAkB;AACrB;;AAEA;GACG,sBAAsB;AACzB;;AAEA;GACG,kBAAkB;GAClB,eAAe;GACf,gBAAgB;GAChB,WAAW;AACd;;AAEA;GACG,8BAA8B;GAC9B,YAAY;GACZ,eAAe;GACf,kBAAkB;GAClB,SAAS;GACT,OAAO;GACP,QAAQ;GACR,YAAY;GACZ,UAAU;GACV,kBAAkB;GAClB,uBAAuB;AAC1B;;AAEA;GACG,UAAU;AACb;;AAEA;GACG,WAAW;GACX,UAAU,CAAC,iBAAiB;AAC/B;;AAEA;GACG,gBAAgB;GAChB,gBAAgB;GAChB,kBAAkB;GAClB,0BAA0B;AAC7B;;AAEA;GACG,gBAAgB;GAChB,gBAAgB;GAChB,0BAA0B;AAC7B;;AAEA;GACG,gBAAgB;GAChB,0BAA0B;AAC7B;;AAEA;GACG,kBAAkB;AACrB;;AAEA;GACG,aAAa;GACb,qBAAqB;GACrB,cAAc;AACjB;;AAEA;GACG,YAAY;GACZ,cAAc;GACd,mBAAmB;GACnB,WAAW;GACX,eAAe;GACf,gBAAgB;AACnB;;AAEA;GACG,mBAAmB;GACnB,WAAW;AACd;;AAEA;GACG,qBAAqB;GACrB,iBAAiB;GACjB,kBAAkB;GAClB,eAAe;GACf,gBAAgB;GAChB,gBAAgB;AACnB;;AAEA;GACG,UAAU;GACV,6BAA6B;GAC7B,WAAW;AACd;;AAEA;GACG,yBAAyB;GACzB,cAAc;GACd,mCAAmC;AACtC;;AAEA;GACG,yBAAyB;GACzB,WAAW;GACX,kCAAkC;AACrC;;AAEA;GACG,yBAAyB;GACzB,WAAW;AACd;;AAEA;GACG;MACG,UAAU;GACb;GACA;MACG,aAAa;GAChB;AACH;;AAEA;GACG;MACG,UAAU;GACb;GACA;MACG,YAAY;GACf;AACH","sourcesContent":[".label-head {\n   color: #777;\n   display: block;\n   font-size: 14px;\n   font-weight: 400;\n   margin: 15px 0 0;\n   padding-bottom: 3px;\n}\n\n.div-company {\n   padding: 10px 20px;\n   margin-top: 60px;\n   margin-left: 30px;\n}\n\ninput, textarea, select {\n   background: transparent;\n   border: 1px solid #e5e5e5;\n   border-radius: 2px;\n   display: block;\n   font-size: 13px;\n   outline: none;\n   padding: 5px;\n   resize: none;\n   width: 80%;\n}\n\n.save-metadata {\n   margin-top: 170px;\n   text-align: right;\n}\n\n.upload-metadata {\n   margin-top: 200px;\n   text-align: right;\n}\n\n.tool-icon {\n   margin-right: 25px;\n   text-align: right;\n}\n\n.mat-raised-button {\n   line-height: 30px;\n}\n\n#btn_edit {\n   display: inline-block;\n}\n\n#btn_cancel {\n   display: none;\n}\n\n#btn_saveType {\n   display: inline-block;\n}\n\n::ng-deep .mat-button:hover .mat-button-focus-overlay {\n   opacity: 0.04 !important;\n}\n\n.mat-icon-button {\n   padding: 0;\n   min-width: 0;\n   width: 40px;\n   height: 50px;\n   flex-shrink: 0;\n   line-height: 40px;\n   border-radius: 50%;\n}\n\n:host::ng-deep .mat-expansion-panel {\n   box-sizing: content-box;\n   display: block;\n   margin: 0;\n   border-radius: 4px;\n   transition: margin 225ms cubic-bezier(0.4, 0, 0.2, 1),box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);\n   height: 100%;\n   width: 100%;\n}\n\n.mat-expansion-panel-header.mat-expanded {\n   height: 64px;\n}\n\n.box-space{\n   width: 100%;\n   margin-right: 4px;\n}\n\nmat-accordion {\n   width: 100%;\n}\n\n.column {\n   width: 33.33%;\n   float: left;\n   padding: 10px;\n   box-sizing: border-box;\n}\n\n.column-full {\n   width: 100%;\n   float: none;\n}\n\n.container {\n   width: 100%;\n   overflow: hidden;\n}\n\nmat-expansion-panel-header {\n   padding-left: 57px;\n}\n\n.panel-body {\n   touch-action: none;\n   padding: 0 24px 5px;\n}\n\n.profile-accordion {\n   display:inline-block;\n   padding: 15px 15px 0px 15px;\n}\n\n.profile-accordion-collapse {\n   display:inline-block;\n   padding: 0px 15px 0px 15px;\n}\n\n.profile-scroll {\n   height: 100%;\n   overflow-y: auto;\n}\n\n.logo {\n   padding: 10px;\n   text-align: center;\n}\n\n.logo img {\n   background-color: #fff;\n}\n\n.container-logo {\n   position: relative;\n   cursor: pointer;\n   min-height: 18px;\n   width: 60px;\n}\n\n.container-logo .change {\n   background: rgba(0, 0, 0, .54);\n   color: white;\n   font-size: 12px;\n   position: absolute;\n   bottom: 0;\n   left: 0;\n   right: 0;\n   padding: 3px;\n   opacity: 0;\n   text-align: center;\n   transition: opacity .2s;\n}\n\n.container-logo:hover .change {\n   opacity: 1;\n}\n\n.inline {\n   margin:10px;\n   float:left;/*Add float left*/\n}\n\n.align-info {\n   line-height: 1.6;\n   margin-top: 10px;\n   margin-bottom: 8px;\n   padding: 5px 16px 12px 5px;\n}\n\n.align-logo-vertical {\n   line-height: 1.6;\n   margin-top: 10px;\n   padding: 5px 16px 12px 5px;\n}\n\n.align-logo-horizontal {\n   line-height: 1.6;\n   padding: 5px 16px 12px 5px;\n}\n\n.cert-card {\n   padding-left: 16px;\n}\n\n.cert-row {\n   display: flex;\n   align-items: baseline;\n   padding: 4px 0;\n}\n\n.cert-label {\n   width: 120px;\n   flex-shrink: 0;\n   white-space: nowrap;\n   color: #777;\n   font-size: 14px;\n   font-weight: 400;\n}\n\n.cert-value {\n   white-space: nowrap;\n   color: #333;\n}\n\n.expire-badge {\n   display: inline-block;\n   padding: 3px 12px;\n   border-radius: 6px;\n   font-size: 13px;\n   font-weight: 600;\n   line-height: 1.6;\n}\n\n.expire-green {\n   padding: 0;\n   background-color: transparent;\n   color: #333;\n}\n\n.expire-yellow {\n   background-color: #facc15;\n   color: #1a1a1a;\n   animation: blink-yellow 1s infinite;\n}\n\n.expire-red {\n   background-color: #ef4444;\n   color: #fff;\n   animation: blink-red 0.8s infinite;\n}\n\n.expire-expired {\n   background-color: #ef4444;\n   color: #fff;\n}\n\n@keyframes blink-yellow {\n   0%, 100% {\n      opacity: 1;\n   }\n   50% {\n      opacity: 0.25;\n   }\n}\n\n@keyframes blink-red {\n   0%, 100% {\n      opacity: 1;\n   }\n   50% {\n      opacity: 0.2;\n   }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
